export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20dark%20theater%20with%20warm%20crimson%20and%20amber%20ambient%20lighting%2C%20abstract%20film%20reel%20texture%2C%20soft%20bokeh%20effects%2C%20luxurious%20cinema%20atmosphere%2C%20dramatic%20composition%20with%20negative%20space%2C%20elegant%20gradient%20from%20deep%20red%20to%20warm%20gold%2C%20no%20text%2C%20atmospheric%20light%20rays&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="桃花影院电影氛围背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-500/20 backdrop-blur-sm border border-primary-500/30 rounded-full px-4 py-1.5 mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-accent-300 whitespace-nowrap">每日更新 · 最新热播</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight">
              桃花影院
              <span className="block text-accent-300 mt-1">免费高清在线观影平台</span>
            </h1>

            <p className="text-sm md:text-base font-medium text-accent-200/80 mt-4 tracking-wide">
              不花钱看大片 · 永久免费无需会员
            </p>

            <div className="mt-6 space-y-3">
              <p className="text-sm md:text-base text-background-200/90 leading-relaxed max-w-[560px] mx-auto lg:mx-0">
                桃花影院是国内领先的免费在线电影院，汇聚海量高清电影与电视剧资源，涵盖最新电视剧全集、热门院线大片、经典老片等丰富内容。所有视频高清流畅不缓冲，无需注册会员即可免费在线观看，是您追剧观影的最佳选择。
              </p>
              <p className="text-sm md:text-base text-background-200/90 leading-relaxed max-w-[560px] mx-auto lg:mx-0">
                平台每日同步更新最新热播剧集，覆盖国产剧、韩剧、美剧、日剧、泰剧等多国剧集，电影频道涵盖动作、喜剧、爱情、科幻、恐怖、动画等全品类，满足您多样化的观影需求。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-7">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-300">20000+</div>
                <div className="text-xs text-background-300/80 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-300">每日更新</div>
                <div className="text-xs text-background-300/80 mt-1">同步热播</div>
              </div>
              <div className="w-px h-10 bg-background-300/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-300">永久免费</div>
                <div className="text-xs text-background-300/80 mt-1">无需会员</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <button
                onClick={() => scrollTo('#index')}
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观影
              </button>
              <button
                onClick={() => scrollTo('#ranking')}
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3 bg-background-50/15 backdrop-blur-sm border border-background-50/25 text-background-50 font-medium rounded-full text-sm hover:bg-background-50/25 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-fire-line mr-2"></i>
                查看热播榜
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/15 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=modern%20cinema%20streaming%20interface%20with%20movie%20posters%20in%20warm%20crimson%20and%20gold%20tones%2C%20minimalist%20UI%20design%2C%20floating%20film%20strips%20and%20play%20buttons%2C%20dark%20elegant%20background%20with%20soft%20glow%20effects%2C%20clean%20modern%20aesthetic%2C%203D%20depth%20layering%20effect&width=1200&height=800&seq=hero-visual-2026&orientation=landscape"
                alt="桃花影院在线观影界面展示"
                className="relative z-10 w-full rounded-2xl shadow-2xl shadow-black/40"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}